import { FunctionComponent, useState } from 'react'
import DashboardItem from '../DashboardItem'
import { TypeOfThreads } from '../CommunityDashboard'
import Paging from 'Features/Paging/paging'
import { useManageThreadsContext } from './ManageThreadsContext'
import ThreadList from './ThreadList'
import SpinnerAbsolute from 'Features/Components/SpinnerAbsolute'
import { IForumSearchResults } from 'Frontend/scripts/models/forums.model'
import { useTranslation } from 'react-i18next'

const UnassignedForumThreads: FunctionComponent = () => {
  const { getThreads, unassignedThreads, isLoading } = useManageThreadsContext()
  const [activePageIndex, setActivePageIndex] = useState<number>(1)
  const { t } = useTranslation()

  const changePage = (activePage: number) => {
    setActivePageIndex(activePage)
    getThreads(activePage, TypeOfThreads.UnassignedThreads)
  }

  if (!unassignedThreads) return <></>

  return (
    <DashboardItem heading={t('all-unassigned-threads')}>
      <SpinnerAbsolute isLoading={isLoading} />
      <ThreadList items={(unassignedThreads as unknown as IForumSearchResults)?.items} />
      {((unassignedThreads as unknown as IForumSearchResults)?.totalPages as number) > 1 && (
        <Paging
          noOfPages={(unassignedThreads as unknown as IForumSearchResults)?.totalPages as number}
          activePage={activePageIndex as number}
          callback={(activePage) => {
            changePage(activePage)
          }}
        />
      )}
    </DashboardItem>
  )
}

export default UnassignedForumThreads
